import { localizeUnits } from '../../../utils/processUnits';
import {
  LocaleGroup,
  LocalizedMeasurementQU,
  ReportMeasurement
} from '../../../types';
import {
  COTTON_CROP_CODE,
  SILAGE_CORN_CROP_CODE,
  SUGARCANE_CROP_CODE
} from '../../../constants/cropCodes';

export const getLocalizedArea = (area: ReportMeasurement): LocalizedMeasurementQU => localizeUnits(
  area.v,
  { key: area.u, localeGroup: LocaleGroup.AREA },
);

export const getLocalizedMoisture = (cropCode: string, averageMoisture: ReportMeasurement): LocalizedMeasurementQU | undefined => {
  const displayMoisture = ![SUGARCANE_CROP_CODE, COTTON_CROP_CODE].includes(cropCode);

  if (displayMoisture) {
    return localizeUnits(
      averageMoisture.v,
      { key: averageMoisture.u, localeGroup: LocaleGroup.MOISTURE }
    );
  }
  
  return undefined;
}

export const getLocalizedAverageYield = (
  cropCode: string,
  averageYield: ReportMeasurement,
  cropNominalWeight?: number
): LocalizedMeasurementQU => {
  switch (cropCode) {
    case SILAGE_CORN_CROP_CODE: {
      return localizeUnits(
        averageYield.v,
        {
          key: averageYield.u,
          localeGroup: LocaleGroup.YIELD_SILAGE, cropNominalWeight
        },
        { cropCode }
      );
    }

    case COTTON_CROP_CODE: {
      return localizeUnits(
        averageYield.v,
        { key: averageYield.u, localeGroup: LocaleGroup.YIELD_COTTON, cropNominalWeight },
        { cropCode }
      );
    }

    case SUGARCANE_CROP_CODE: {
      return localizeUnits(
        averageYield.v,
        { key: averageYield.u, localeGroup: LocaleGroup.YIELD_SUGARCANE, cropNominalWeight },
        { cropCode }
      );
    }

    default: {
      return localizeUnits(
        averageYield.v,
        { key: averageYield.u, localeGroup: LocaleGroup.YIELD, cropNominalWeight },
        { cropCode }
      );
    }
  }
}

interface GetLocalizedTotalWeightParams {
  cropCode: string,
  totalWeight: ReportMeasurement,
  cropNominalWeight?: number
}

export const getLocalizedTotalWeight = ({
  cropCode,
  totalWeight,
  cropNominalWeight
}: GetLocalizedTotalWeightParams): LocalizedMeasurementQU | undefined => {
  switch (cropCode) {
    case SILAGE_CORN_CROP_CODE: {
      return localizeUnits(
        totalWeight.v,
        { key: totalWeight.u, localeGroup: LocaleGroup.WEIGHT_DRY_YIELD, cropNominalWeight },
        { cropCode }
      );
    }

    case COTTON_CROP_CODE: {
      return localizeUnits(
        totalWeight.v,
        {
          key: totalWeight.u,
          localeGroup: LocaleGroup.WEIGHT_COTTON,
          cropNominalWeight
        },
        { cropCode }
      );
    }

    case SUGARCANE_CROP_CODE: {
      return localizeUnits(
        totalWeight.v,
        { key: totalWeight.u, localeGroup: LocaleGroup.WEIGHT, cropNominalWeight },
        { cropCode }
      );
    }

    default: {
      return localizeUnits(
        totalWeight.v,
        { key: totalWeight.u, localeGroup: LocaleGroup.WEIGHT_YIELD, cropNominalWeight },
        { cropCode }
      );
    }
  }
}